import React from 'react';

const Header = () => {
  return (
    <header>
      {/* <h1>Hola! soy Franco</h1>*/}


    </header>
    
  );
};

export default Header;
